import { render, staticRenderFns } from "./RegisteredSpecialtiesTable.vue?vue&type=template&id=594d7b2e"
import script from "./RegisteredSpecialtiesTable.vue?vue&type=script&lang=js"
export * from "./RegisteredSpecialtiesTable.vue?vue&type=script&lang=js"
import style0 from "./RegisteredSpecialtiesTable.vue?vue&type=style&index=0&id=594d7b2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports